import { FilterField, FilterFieldType } from '../filter';

export class DatePickerFilterField extends FilterField<Date> {
  readonly type: FilterFieldType = 'date-picker';

  appliedFieldText(): string {
    return `${this.name}: ${this.value!.toDateString()}`;
  }

  serializeValue(): string {
    return this.value!.toISOString();
  }

  deserializeValue(urlParam: string): Date {
    return new Date(urlParam);
  }
}
